import { gql } from '@apollo/client';
import Category from './category';
import { Page } from './page';

export const InternalLinkBlock = gql`
    fragment InternalLinkBlock on InternalLinkRecord {
        __typename
        label
        link {
            ...Category
            ...Page
        }
        openInNewWindow
    }
    ${Category}
    ${Page}
`;

export const ExternalLinkBlock = gql(`
    fragment ExternalLinkBlock on ExternalLinkRecord {
        __typename
        label
        url
        openInNewWindow
    }
`);
